let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8Ygi9")).then(() => parcelRequire('fS2a6'));